import React from 'react';
import { ShieldCheckIcon, FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0A71B1] text-white pt-16 pb-8" role="contentinfo" data-id="element-88">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-90">
          {/* About */}
          <div className="space-y-5" data-id="element-91">
            <div className="flex items-center" data-id="element-92">
              <img src="https://cdn.magicpatterns.com/uploads/s899UuCsAYeWwVHcPPvFSS/healthy_choice_logo.png" alt="Healthy Choice Family Clinic & Urgent Care" className="h-14 w-auto object-contain brightness-0 invert" data-id="element-93" />
            </div>
            <p className="text-base text-white/70 leading-relaxed" data-id="element-94">
              Comprehensive family medicine and urgent care serving Landover and
              Oxon Hill, Maryland. Walk-ins welcome.
            </p>
          </div>

          {/* Locations */}
          <div data-id="element-95">
            <h3 className="font-bold text-xl mb-6 text-white" data-id="element-96">Locations</h3>
            <ul className="space-y-4 text-base text-white/70" data-id="element-97">
              <li className="flex items-start gap-2" data-id="element-98">
                <MapPinIcon className="h-5 w-5 text-teal-500 flex-shrink-0 mt-0.5" data-id="element-99" />
                <div data-id="element-100">
                  <p data-id="element-101">8700 Central Ave #302A</p>
                  <p data-id="element-102">Landover, MD 20785</p>
                  <a href="tel:3016139295" className="text-teal-400 hover:text-teal-300 transition-colors flex items-center gap-1 mt-1" data-id="element-103">
                    <PhoneIcon className="h-3.5 w-3.5" data-id="element-104" /> (301) 613-9295
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2" data-id="element-105">
                <MapPinIcon className="h-5 w-5 text-teal-500 flex-shrink-0 mt-0.5" data-id="element-106" />
                <div data-id="element-107">
                  <p data-id="element-108">6188 Oxon Hill Rd #601</p>
                  <p data-id="element-109">Oxon Hill, MD 20745</p>
                  <a href="tel:2405537993" className="text-teal-400 hover:text-teal-300 transition-colors flex items-center gap-1 mt-1" data-id="element-110">
                    <PhoneIcon className="h-3.5 w-3.5" data-id="element-111" /> (240) 553-7993
                  </a>
                </div>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-112">
            <h3 className="font-bold text-xl mb-6 text-white" data-id="element-113">Quick Links</h3>
            <ul className="space-y-3" data-id="element-114">
              <li data-id="element-115">
                <a href="/#services" className="text-base text-white/70 hover:text-teal-400 transition-colors min-h-[44px] inline-flex items-center" data-id="element-116">
                  Services
                </a>
              </li>
              <li data-id="element-117">
                <a href="/team" className="text-base text-white/70 hover:text-teal-400 transition-colors min-h-[44px] inline-flex items-center" data-id="element-118">
                  Our Team
                </a>
              </li>
              <li data-id="element-119">
                <a href="/blog" className="text-base text-white/70 hover:text-teal-400 transition-colors min-h-[44px] inline-flex items-center" data-id="element-120">
                  Blog
                </a>
              </li>
              <li data-id="element-121">
                <a href="/careers" className="text-base text-white/70 hover:text-teal-400 transition-colors min-h-[44px] inline-flex items-center" data-id="element-122">
                  Careers
                </a>
              </li>
              <li data-id="element-123">
                <a href="#portal" className="text-base text-white/70 hover:text-teal-400 transition-colors min-h-[44px] inline-flex items-center" data-id="element-124">
                  Patient Portal
                </a>
              </li>
            </ul>
          </div>

          {/* Legal & Contact */}
          <div data-id="element-125">
            <h3 className="font-bold text-xl mb-6 text-white" data-id="element-126">Legal</h3>
            <ul className="space-y-3 mb-6" data-id="element-127">
              <li data-id="element-128">
                <a href="#privacy" className="text-base text-white/70 hover:text-teal-400 transition-colors min-h-[44px] inline-flex items-center" data-id="element-129">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-130">
                <a href="#hipaa" className="text-base text-white/70 hover:text-teal-400 transition-colors min-h-[44px] inline-flex items-center" data-id="element-131">
                  HIPAA Notice
                </a>
              </li>
              <li data-id="element-132">
                <a href="#accessibility" className="text-base text-white/70 hover:text-teal-400 transition-colors min-h-[44px] inline-flex items-center" data-id="element-133">
                  Accessibility
                </a>
              </li>
            </ul>
            <a href="mailto:info@hcfclinics.com" className="text-base text-teal-400 hover:text-teal-300 transition-colors flex items-center gap-2" data-id="element-134">
              <MailIcon className="h-4 w-4" data-id="element-135" /> info@hcfclinics.com
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-136">
          <p className="text-white/60 text-base" data-id="element-137">
            © 2026 Healthy Choice Family Clinic & Urgent Care. All rights
            reserved.
          </p>

          <div className="flex gap-4" data-id="element-138">
            <a href="#" className="text-white/60 hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm p-1" aria-label="Facebook" data-id="element-139">
              <FacebookIcon className="h-5 w-5" data-id="element-140" />
            </a>
            <a href="#" className="text-white/60 hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm p-1" aria-label="Twitter" data-id="element-141">
              <TwitterIcon className="h-5 w-5" data-id="element-142" />
            </a>
            <a href="#" className="text-white/60 hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm p-1" aria-label="Instagram" data-id="element-143">
              <InstagramIcon className="h-5 w-5" data-id="element-144" />
            </a>
            <a href="#" className="text-white/60 hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm p-1" aria-label="LinkedIn" data-id="element-145">
              <LinkedinIcon className="h-5 w-5" data-id="element-146" />
            </a>
          </div>

          <div className="flex items-center gap-1.5 text-white/80 text-base bg-white/10 px-4 py-2 rounded-full border border-white/20" data-id="element-147">
            <ShieldCheckIcon className="h-4 w-4 text-teal-500" aria-hidden="true" data-id="element-148" />
            <span className="font-semibold tracking-wide" data-id="element-149">HIPAA Compliant</span>
          </div>
        </div>
      </div>
    </footer>;
}